import { defineStore } from "pinia";
import { api } from "../scripts/api.ts";

export const useFavoriteStore = defineStore("favorite", () => {
    const toggleFavorite = async (product_id) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await api().post(`/site/favorite/toggle/`, {
                    product_id: product_id,
                });
                resolve(response.data.data);
            } catch (e) {
                reject(e);
            }
        });
    };

    return {
        toggleFavorite,
    };
});
